"use strict";
var ACC;
$(document).ready(function(){

/************************************************** Footer Links ***********************************************************/

  ACC.accordion.bindAccordionEvent($(".footer-navigation"), ".arrow-icon");

  ACC.accordion.bindAccordionEvent($(".tree-navigation-mobile"), ".name");


  // add a CSRF request token to POST ajax request if its not available
  $.ajaxPrefilter(function (options, originalOptions, jqXHR)
  {
    // Modify options, control originalOptions, store jqXHR, etc
    if (options.type === "post" || options.type === "POST")
    {
      var noData = (typeof options.data === "undefined");
      if (noData || options.data.indexOf("CSRFToken") === -1)
      {
        ACC.config.CSRFToken = ACC.common.getCSRFTokenJS();
        const csrfToken = ACC.config.CSRFToken;
        options.data = (!noData ? options.data + "&" : "") + "CSRFToken=" + csrfToken;
      }
    }
  });

  if($('img[usemap]').length>0){
    $('img[usemap]').rwdImageMaps();
  }

/********************************************** Header Search form ***********************************************/
  $(".header-search-link.header-web-navigation button").on('click' , function(){
    if ($(".cookie-container").is(':hidden') === false){
      if ($(".searchbox").hasClass('cookieOpened') === false){
        $(".searchbox").addClass('cookieOpened');
      }
    } else {
      if ($(".searchbox").hasClass('cookieOpened') === true ){
        $(".searchbox").removeClass('cookieOpened');
      }
    }
  });

  $(".header-search-link.header-web-navigation button.top-search-btn").on('click' , function(){
    if($("button").hasClass("header-submit-search-button-mobile")) {
      $(".search-mask").show();
      $(".header-search-input-box").slideDown(400,function(){
        $("#js-site-search-input").focus();
      });
      $("html").addClass('disable-scroll');

    } else {
      $(".search-mask").fadeToggle();
      $(".header-search-input-box").slideToggle(400,function(){
        $("#js-site-search-input").focus();
      });
      $("html").addClass('disable-scroll');
    }
  });

  $("#dtSearchbar form, #mbSearchbar form").on("submit", function() {
    // This is used in gtm for tracking last searched term.
    localStorage.setItem('searchTerm', $('input[type="search"]', this).val().trim());
    // this function is fired only when enter is pressed directly on the input field
    // by design, dimension83 should become null
    localStorage.removeItem("searchCategorySuggestion");
    // Prevent search form submit on empty value.
    return $("input[type='search']", this).val().trim().length > 0;
  });

  $('.search-box-close').on('click', function(){
    $(".header-search-input-box").slideUp();
    $("#js-site-search-input").val('');
    $(".search-mask").fadeOut('fast');
    $("html").removeClass('disable-scroll');
  });

  $('.search-mask').on('click', function(){
    $(".header-search-input-box").slideUp();
    $("#js-site-search-input").val('');
    $(".search-mask").fadeOut('fast');
    $("html").removeClass('disable-scroll');
  });

  $('.searchbox').on('click', function(){
    $(".header-search-input-box").slideUp();
    $("#js-site-search-input").val('');
    $(".search-mask").fadeOut('fast');
    $("html").removeClass('disable-scroll');
  });

  // Mobile nav
  $(".header-search-link.header-mobile-navigation .js-toggle-sm-navigation").on('click' , function(){
    // commented because it would lead to the DT searchbar to be shown when using the new 1280 tablet breakpoint
    // $(".header-search-input-box").show();
    //$("#js-site-search-input").focus();
    $(".searchbox").show();
    $(".search-mask").toggle();
    if($("main").hasClass('offcanvas')) {
      $(".header-top-row").addClass('nav-active');
      $("body").addClass('no-scroll');
    } else {
      $(".header-top-row").removeClass('nav-active');
      $("body").removeClass('no-scroll');
    }
  });

  // Search Clear on text input
  $("#js-site-search-input").on('keyup input', function () {
    var searchText = this.value.length;
    if (searchText > 0) {
    $(".search-clear").show();
    } else {
    $(".search-clear").hide();
    }
  });

  $("#js-site-search-input").on('blur', function () {
    var searchText = this.value.length;
    if (searchText === 0) {
      $('#mobileMenu').removeClass('searchResultsOpen');
    }
  });

  $("#mbSearchbar #js-site-search-input").on("click", function () {
    $(".searchBackdrop").css("display", "block");
    $("#dtLogoBackdrop").css("display", "none");
    $("html").addClass("no-scroll");
  });

  $("#mbSearchbar #js-site-search-input").on("blur", function () {
    $(".searchBackdrop").css("display", "none");
    $("#dtLogoBackdrop").css("display", "none");
    $("html").removeClass("no-scroll");
  });

  $("#dtSearchbar #js-site-search-input").on("click", function () {
    $(".searchBackdrop").css("display", "block");
    $("html").addClass("no-scroll");
  });

  $("#dtSearchbar #js-site-search-input").on("blur", function () {
    $(".searchBackdrop").css("display", "none");
    $("html").removeClass("no-scroll");
  });

  // Search Clear search clear button press
  $(".search-clear").on('click' , function(){
    $("#js-site-search-input").val('');
    $(".search-clear").hide();
    $("#js-site-search-input").focus();
  });


/**************************************** Add background colour to the search box if in the HMC ************/
  if($(".search-colour").val()){
    var searchColour = $(".search-colour").val();
    $(".searchbox").css('background', searchColour);
  }


/**************************************** Get Exising Select Options *****************************************/

(function initSizeSelect() {
    var $sizeForm = $('form#product'),
        $sizeSelect = $sizeForm.find('select');

    $sizeSelect.each(function (i, elem) {
        var $select = $(elem);
        var $selectLabel = $select.siblings('.variant-name');

        // Create and add a fieldset element:
        var $fieldset = $("<fieldset>");
        $fieldset.attr({
            "class": "variant-selector__options",
            "aria-required": "true",
            "aria-invalid": "true",
            "aria-labelledby": "selectSizeTitle",
            "role": "radiogroup"
        });
        $select.after($fieldset);

        $select.find("option").each(function(j, option) {
            var $option = $(option);

            // Create a div:
            var $div = $("<div class='radio-container'></div>");
            $fieldset.append($div);

            // Create a radio:
            var $radio = $("<input>");
            $radio.attr({
                "type": "radio",
                "name": $select.attr("name"),
                "id": 'size-option-' + $option.val(),
                "data-product-code": $option.val(),
            });
            // Set checked if the option was selected
            if ($option.attr("selected")) {
                $radio.attr("checked", "checked");
                $radio.prop('checked', true);
                $fieldset.attr("aria-invalid", "false");
            }
            // Add radio to radio-container:
            $div.append($radio);

            // Create a label for the radio:
            var $label = $("<label>");
            $label.attr({
                "for": $radio.attr("id"),
                "class": "variantlabel",
                "data-stock-value": $option.data("stock-value")
            }).text($option.text());
            // Add label to radio-container:
            $div.append($label);
        });

        $select.remove();
        $selectLabel.remove();
    });

    $sizeForm.trigger('sizeSelectInit');
})();



/***************************** Hide Select Size option from radio buttons conversion  ********************************/

  if ($("label:contains('Select a size')")) {
    $("label:contains('Select a size')").hide();
  }



/***************************** Styled Internal Scrollbar ***************************************************************/

  if ($(window).width() > 768) {
    $('.scroll-pane').jScrollPane();
  }

// Editorial check grid for empty content

if($('.multiple-content-grid-container').length){

  $('.multiple-content-text-container').each(function(){
    if($.trim($(this).text()) === ''){
      $(this).css('border', '0');
    }
  });

}

/**********************************  Mobile detection code for Badges  **************/
function mobileBadges(){
  var mobile = (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
  if (mobile) {
    $( ".product-item" ).each(function() {
       if($(".product-badge", this).hasClass('product-badge-department')) {
         $(".product-badge",this).addClass('product-badge-mobile-class');
         $(".product-badge.product-badge-material.product-badge-mobile-class").hide();
      }
    });
  } else {
    $(".product-badge-material").show();
    $(".product-badge.product-badge-material.product-badge-mobile-class").show();
  }
}
mobileBadges();



/****************************** International Store Toggle Styling Fix *************/

$(".int-stores").on('click', function(){
  $("#internationalStorefinder").toggle().toggleClass('footer-adjust');
  if($("#internationalStorefinder").hasClass('footer-adjust')) {
    $(".main-footer").css('margin', '0');
    $("#internationalStores button").css('margin-bottom','0');
    $(this).find('span').removeClass('icon-down-open-mini').addClass('icon-up-open-mini');
  } else {
    $(".main-footer").css('margin', '15px 0 0');
    $(this).find('span').removeClass('icon-up-open-mini').addClass('icon-down-open-mini');
  }
});

/****************************** Scroll to delivery options on click *****************/

if($(".checkout-delivery-option-list").hasClass('delivery-scroll-point')) {
  var topSpot = sessionStorage.getItem('checkoutTopPosition');

  $('html, body').animate({
    scrollTop: topSpot
  }, 20);

  sessionStorage.removeItem('checkoutTopPosition');
}


/************** No Validate email fields via HTML 5 Browser validation **************/
$('input').attr('novalidate', 'novalidate');

/****************************** Flick of content Fix *******************************/
/****************************** This should load last ******************************/

$(".flick-fix").show();


/******************************* End of Document Ready *****************************/

});

/**
 * Handle requestAnimationFrame() in multiple browsers:
 *
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 *
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * MIT license
 */
(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];

    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame =
        window[vendors[x] + 'CancelAnimationFrame'] ||
        window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
})();

// No Code should appear after here other than on load.
$(window).on('load', function() {
    $('.media-item .media-item-img').find('img').each(function() {
        var imgClass = (this.width / this.height > 1) ? 'wide' : 'tall';
        $(this).addClass(imgClass);
    });
});
